import type from './POTemplate.type';

const initialState = {
  templates: [],
  templateList: [],
  oldTemplates: [],
  templateDetails: null,
  newPreviewData: null,
  previewData: null,
  totalNewTemplatesCount: 0,
  totalOldTemplatesCount: 0,
};

const POTemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_PO_TEMPLATES:
      return { ...state, templates: action.payload?.data, totalNewTemplatesCount: action.payload?.totalCount };
    case type.APPEND_PO_TEMPLATES:
      return { ...state, templates: [...(state.templates || []), ...action.payload] };
    case type.FETCH_PO_TEMPLATE_LIST:
      return { ...state, templateList: action.payload || [] };
    case type.FETCHING_OLD_PO_TEMPLATES:
      return { ...state, oldTemplates: action.payload?.data, totalOldTemplatesCount: action.payload?.totalCount };
    case type.APPEND_OLD_PO_TEMPLATES:
      return {
        ...state,
        oldTemplates: [...(state.oldTemplates || []), ...(action.payload?.data || [])],
      };
    case type.RESET_OLD_PO_TEMPLATES:
      return { ...state, oldTemplates: [] };
    case type.RESET_ALL_TEMPLATES:
      return { ...state, templates: [], oldTemplates: [], totalNewTemplatesCount: 0, totalOldTemplatesCount: 0 };
    case type.DELETE_PO_TEMPLATE:
      return { ...state, templates: state?.templates?.filter((template) => !action?.payload?.includes(template._id)) };
    case type.DELETE_OLD_PO_TEMPLATE:
      return { ...state, oldTemplates: state?.oldTemplates?.filter((template) => !action?.payload?.includes(template._id)) };
    case type.UPDATE_PO_TEMPLATE_ACTIVE:
      return {
        ...state,
        templates: state?.templates?.map((template) =>
          template?._id === action?.payload?.id ? { ...template, isActive: action?.payload?.isActive } : template,
        ),
      };
    case type.GET_POTEMPLATE_DETAILS:
      return { ...state, templateDetails: action.payload };
    case type.RESET_POTEMPLATE_DETAILS:
      return { ...state, templateDetails: null };
    case type.GET_PREVIEW_DATA:
      return { ...state, previewData: action.payload };
    case type.CLEAR_PREVIEW_DATA:
      return { ...state, previewData: null, newPreviewData: null };
    case type.GET_NEW_PREVIEW_DATA:
      return { ...state, newPreviewData: action.payload };
    default:
      return state;
  }
};

export default POTemplateReducer;
